class CountdownTimer extends HTMLElement {
  constructor() {
    super();
    // Retrieve the countdown date from the element's attribute
    const countdownDateFromAttribute = this.getAttribute('data-countdown-date');
    this.countdownDate = new Date(countdownDateFromAttribute).getTime();
  }

  connectedCallback() {
    // Start the countdown update when the element is added to the document
    this.updateCountdown();
    this.interval = setInterval(() => this.updateCountdown(), 1000);
  }

  disconnectedCallback() {
    // Clear the interval when the element is removed from the document
    clearInterval(this.interval);
  }

  updateCountdown() {
    const now = new Date().getTime();
    const timeLeft = this.countdownDate - now;

    const days = Math.floor(timeLeft / (1000 * 60 * 60 * 24));
    const hours = Math.floor((timeLeft % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((timeLeft % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((timeLeft % (1000 * 60)) / 1000);

    // Update the text content of the countdown
    this.querySelector('#days').textContent = days;
    this.querySelector('#hours').textContent = hours;
    this.querySelector('#minutes').textContent = minutes;
    this.querySelector('#seconds').textContent = seconds;
  }
}

// Register the custom element
if (!customElements.get('countdown-timer')) {
  customElements.define('countdown-timer', CountdownTimer);
}
